export const PUMA_APP_ID = '6d0f41e3-8465-4aa1-a69b-c2d0359e5bd1'; //https://issues.amazon.com/D19370817
export const PUMA_MODULE_NAME = "DOLPHIN_PROBLEM_SOLVE_";